export function sanitizeNextPath(candidate) {
  if (typeof candidate !== "string") return null;

  const trimmed = candidate.trim();
  if (!trimmed.startsWith("/")) return null;
  if (trimmed.startsWith("//")) return null;
  if (trimmed.includes("\\")) return null;

  return trimmed;
}

export function buildNextPath(locationLike = {}) {
  const pathname = locationLike.pathname || "/";
  const searchParams = new URLSearchParams(locationLike.search || "");
  const hash = locationLike.hash || "";

  if (pathname.startsWith("/order-details/")) {
    searchParams.delete("token");
  }

  const nextSearch = searchParams.toString();
  return `${pathname}${nextSearch ? `?${nextSearch}` : ""}${hash}`;
}
